import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, ToggleButtonGroup, ToggleButton, Card, CardContent, Alert, AlertTitle, Button } from '@mui/material';
import MainCard from '../MainCard';
import SelectTable from '../SelectTable';
import axios from "../../../components/axios";
import CustomDatePicker from '../CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import TextFieldCommon from './TextFieldCommon';


const DefaultErlichPage = ({title, columns, queryURL, downloadURL}) => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = useState('and');
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [selected, setSelected] = useState([]);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [search, setSearch] = useState("");
  function searchChange(e) {
    setSearch(e.target.value);
  }

  const [open, setOpen] = useState(false);
  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const styleToggle = {
    marginTop: "10px",
    color:'#406599',
    fontFamily: '"Roboto", "sans-serif"',
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignment(newAlignment);
  };

  const handleDownload = (id) => {
        var input_data = JSON.stringify({ item_id: id });
        axios.post(downloadURL, input_data, {withCredentials: true})
        .then(response => {
          if (response.data.message === "success") {
            window.open(response.data.url, "_blank");
          }else{
            alert(response.data.message);
          }
        })
        .catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else if (err.response.status === 406) {
              if (err.response.data.user){
                localStorage.setItem("qbarn.user", JSON.stringify(err.response.data.user))
                navigate("/");
              }
            }else{
              console.log('error.response.status: ', err.response.status)
              console.log('error.response.status: ', err.response.data.message)
              alert(err.response.data.message)
            }
          }
        })
    };

  const handleQueryData = () => {
    if (search === "" && state[0].startDate === null && state[0].endDate === null ){
      alert("Please select query date range or keyword!");
    }else{
      setRows([]);
      setSelected([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }
      var input_data = JSON.stringify({ query: search, start_date: startDateStr,
        end_date: endDateStr, condition: alignment })
      axios.post(queryURL,input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null){
            setRows(response.data.data);
            setshowTable(true);
          }else{
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
    }
  };

  const handleClear = () => {
    setSearch('');
  };

  return (
    <MainCard title={title}>
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
          {title}
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={3}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={4}>
          <TextFieldCommon search={search} searchChange={searchChange} handleClear={handleClear}/>
        </Grid>
        <Grid item xs={1}>
          <ToggleButtonGroup
            color="error"
            size="small"
            value={alignment}
            exclusive
            onChange={handleChange}
            style={styleToggle}
          >
            <ToggleButton value="and" color="info">AND</ToggleButton>
            <ToggleButton value="or" color="info">OR</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item xs={1}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      { showTable && (<SelectTable
                      rows={rows}
                      columns={columns}
                      handleDownload={handleDownload}
                      selected={selected}
                      setSelected={setSelected}/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        No data in this condition.
      </Alert></Card>)}
    </MainCard>
  );
};

export default DefaultErlichPage;
